import MemberRoleInstantChange from './MemberRoleInstantChange.component';

export default MemberRoleInstantChange;
